import { ReactNode } from 'react';
import { useClinicalEventsModal } from './Provider';
import clinicalEventConfirmAlert from '../clinicalEventConfirmAlert';
import { IconButton } from '@mui/material';
import useQueryParam from '../../../../hooks/useCustomQueryParam';
import alertStyles from '../clinicalEventConfirmAlert/index.module.scss';
import useIsPrimaryTheme from '../../../../hooks/useIsPrimaryTheme';

const CloseDrawer = ({
  children,
  className,
  isDirty,
}: {
  children: ReactNode;
  className?: string;
  isDirty?: boolean;
}) => {
  const [, setNewEvent] = useQueryParam<string | undefined>('newEventUuid');
  const { setContextData } = useClinicalEventsModal();
  const closeDrawer = () => setContextData();
  const isPrimaryTheme = useIsPrimaryTheme();

  const onClose = () => {
    setNewEvent(undefined);
    closeDrawer();
  };

  const confirmClose = () =>
    clinicalEventConfirmAlert({
      title: 'Exit form',
      body: `You're about to close the form. Unsaved changes will not be saved`,
      onClick: onClose,
      primaryBtnText: 'Yes, close this form',
      classes: {
        btn: isPrimaryTheme ? alertStyles.primaryP3Main : '',
      },
    });

  return (
    <IconButton
      onClick={isDirty ? confirmClose : onClose}
      className={className}>
      {children}
    </IconButton>
  );
};

export default CloseDrawer;
